import { Component, Input, OnChanges, SimpleChange  } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { FleetConfiguration } from '../../model/fleet-configuration';

@Component({
  selector: 'ready-to-complete',
  styles: [require('../../icc.scss')],
  template: require('./ready-to-complete.html'),
    providers: [
      TranslateService
  ]
})
export class ReadyToComplete {
  @Input() fleetConfig: FleetConfiguration;
  @Input() errorMessage: string;
  @Input() errorFlag: boolean;
  @Input() saveOperationInProgress: boolean;

  private isTranslationready: boolean = true;

 constructor(private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/wizard/steps/ready-to-complete.component.ts